import { useEffect, useState } from "react";
import { InfoGetInfo } from "../../Api/Services";

function Footer() {
  const [form, setForm] = useState({});

  const start = async () => {
    try {
      const { status, data } = await InfoGetInfo();
      if (status === 200 && data?.data) {
        setForm(data.data);
      }
    } catch (error) {
      console.error("Error Footer:", error);
    }
  };

  useEffect(() => {
    start();
  }, []);

  return (
    <footer
      className="w-100 bg-dark text-light pt-5 pb-4 PanelElement mt-5"
      dir="rtl"
    >
      <div className="container">
        <div className="row">
          {/* درباره ما */}
          <div className="col-md-4 mb-3">
            <h5 className="mb-3">درباره ما</h5>
            <p className="small">{form.description}</p>
          </div>

          {/* تماس با ما */}
          <div className="col-md-4 mb-3">
            <h5 className="mb-3">تماس با ما</h5>
            {form.phone && <p className="small mb-1">📞 {form.phone}</p>}
            {form.tell && <p className="small mb-1">☎️ {form.tell}</p>}
            {form.email && (
              <p className="small mb-1">
                ✉️{" "}
                <a className="text-light" href={`mailto:${form.email}`}>
                  {form.email}
                </a>
              </p>
            )}
            {form.address && <p className="small mb-1">📍 {form.address}</p>}
            {form.fax && <p className="small mb-1">📠 {form.fax}</p>}
            {form.time && <p className="small mb-1">⏰ {form.time}</p>}
          </div>

          {/* شبکه‌های اجتماعی */}
          <div className="col-md-4 mb-3">
            <h5 className="mb-3">ما را دنبال کنید</h5>
            <div className="d-flex gap-3 fs-4">
              {form.telegram && (
                <a
                  href={form.telegram}
                  target="_blank"
                  rel="noreferrer"
                  className="text-light"
                >
                  <i className="bi bi-telegram"></i>
                </a>
              )}
              {form.whatsApp && (
                <a
                  href={`https://wa.me/${form.whatsApp.replace(
                    /^0/,
                    "98"
                  )}?text=${encodeURIComponent(
                    "سلام، من از سایت شما  دیدن کردم"
                  )}`}
                  target="_blank"
                  rel="noreferrer"
                  className="text-light"
                >
                  <i className="bi bi-whatsapp"></i>
                </a>
              )}

              {form.bale && (
                <a
                  href={form.bale}
                  target="_blank"
                  rel="noreferrer"
                  className="text-light"
                >
                  <i className="bi bi-chat-dots"></i>
                </a>
              )}
              {form.eita && (
                <a
                  href={form.eita}
                  target="_blank"
                  rel="noreferrer"
                  className="text-light"
                >
                  <i className="bi bi-chat"></i>
                </a>
              )}
              {form.instagram && (
                <a
                  href={form.instagram}
                  target="_blank"
                  rel="noreferrer"
                  className="text-light"
                >
                  <i className="bi bi-instagram"></i>
                </a>
              )}
            </div>
          </div>
        </div>

        <hr className="border-secondary" />

        <div className="d-flex justify-content-between">
          <a
            referrerpolicy="origin"
            target="_blank"
            href="https://trustseal.enamad.ir/?id=691821&Code=3yTe3S0A2MWw6YEuDve0qR2GLMW0hcen"
          >
            <img
              referrerpolicy="origin"
              src="https://trustseal.enamad.ir/logo.aspx?id=691821&Code=3yTe3S0A2MWw6YEuDve0qR2GLMW0hcen"
              alt=""
              style={{"cursor":"pointer"}}
              code="3yTe3S0A2MWw6YEuDve0qR2GLMW0hcen"
            />
          </a>
        </div>

        <div className="text-center small mt-3">
          © 2025 تمام حقوق محفوظ است | طراحی و توسعه توسط
          <strong> شرکت توسعه اندیشه پویا پارس</strong>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
